import type { AdminHomeDashboardFilterParams } from "../../slices/admin-home-dashboard/Types";

export const adminHomeDashboardSagaActionTypes = {
  callGetAdminHomeDashboardSaga: "callGetAdminHomeDashboardSaga",
};

export const getAdminHomeDashboardSagaAction = (
  filters: AdminHomeDashboardFilterParams = {}
) => ({
  type: adminHomeDashboardSagaActionTypes.callGetAdminHomeDashboardSaga,
  filters,
});
